import React, { useEffect, useState } from "react";
import CreatableSelect from "react-select/creatable";

const CompaniesSelectInput = ({ value, onChange, disabled }) => {
  const [companiesList, setCompaniesList] = useState([]);
  const [searchInput, setSearchInput] = useState("");

  
  useEffect(() => {
    const delayTimer = setTimeout(() => {
      if (searchInput !== null) {
        fetchCompaniesList(searchInput);
      }
    }, 300);

    return () => clearTimeout(delayTimer);
  }, [searchInput]);

  const fetchCompaniesList = async (search = "") => {
    //TODO: Get this from ENV
    const mauticURL = process.env.REACT_APP_CRM_ADMIN ;

    try {
      const response = await fetch(mauticURL + "/api/crm/companies/list", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          search: search,
        }),
      });
      const findresponse = await response.json();

      if (findresponse && findresponse.code === 200) {
        setCompaniesList(findresponse.data || []);
      }
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  return (
    <CreatableSelect
      value={value}
      className="single-select"
      classNamePrefix="single-select"
      closeMenuOnSelect={true}
      hideSelectedOptions={false}
      onChange={(event) => onChange(event ? event.value : "")}
      onInputChange={(inputValue, { action }) => {
        if (action === "input-change") {
          setSearchInput(inputValue);
        }
      }}
      onBlur={(event) => {
        // Preserve the typed value on blur if nothing was selected
        const inputValue = event.target.value;
        if (inputValue && inputValue.trim() !== "") {
          onChange(inputValue);
        }
      }}
      options={(companiesList || []).map((item) => {
        return { label: item.value, value: item.id };
      })}
      isDisabled={disabled}
      menuPortalTarget={document.body}
      menuPosition="fixed"
      styles={{
        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
      }}
      placeholder="Type or select a company name..."
    />
  );
};

export default CompaniesSelectInput;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/common/ConpaniesSelectInput.js